import {defineStore} from 'pinia'
import Roles from "~/utils/roles"

export const useWalkthroughStore = defineStore('walkthrough', {
    state: () => ({
        pilots: false,
        zoneRequest: false,
        teamZone: false,
    }),
    getters: {
        state: (state: any) => {
            return state
        },
    },
    actions: {
        async load() {
            const {user} = useAuth()
            if (user.value?.role !== Roles.ISTAR_DIVISION.value) {
                return
            }

            const walkthroughData = await useApi().getWalkthroughStatus()

            this.pilots = walkthroughData.pilots
            this.zoneRequest = walkthroughData.zoneRequest
            this.teamZone = walkthroughData.teamZone
        },
    },
})